import { IconBase, IconBaseProps } from 'react-icons';
import { IconManifest } from 'app/agriculture/icons/types';

const directionIcon: IconManifest = {
    id: 'direction-icon',
    width: 128,
    height: 128,
    d: 'M63.983 16c2.514 0 4.761 1.522 5.63 3.814l31.983 84.341c.872 2.299.171 4.883-1.754 6.465-1.925 1.583-4.663 1.827-6.853.612L63.983 95.129l-29.006 16.103c-2.19 1.215-4.928.971-6.853-.612-1.925-1.582-2.626-4.166-1.754-6.465l31.983-84.34c.87-2.293 3.116-3.815 5.63-3.815ZM43.325 93.17l17.681-9.817a6.153 6.153 0 0 1 5.954 0l17.682 9.817-20.659-54.48-20.658 54.48Z',
};

export function DirectionIcon(props: IconBaseProps) {
    const { id, d } = directionIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="DirectionIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
